import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useAuthStore from "../stores/useAuthStore";

export default function requireAuth(ComposedComponent) {
  function Authentication(props) {
    const navigate = useNavigate();
    const authenticated = useAuthStore((state) => state.authenticated);

    useEffect(() => {
      if (!authenticated) {
        navigate("/login");
      }
    }, [authenticated, navigate]);

    if (!authenticated) return null;
    return <ComposedComponent {...props} />;
  }

  return Authentication;
}
